<template>
  <customModal :containersm="true" @closeModal="closeModal">

    <template #title>
      {{ isEditMode ? 'Update Phase' : 'Create Phase' }}
    </template>

    <template #body>
      <div class="row">

        <!-- Phase Name -->
        <div class="col-md-6 form-group mb-2">
          <label class="mb-0">
            Phase Name <sup><i class="fa fa-asterisk required"></i></sup>
          </label>

          <input v-model="phase.name" @input="clearError" class="form-control" type="text" />

          <span v-if="errors.name" class="errormsg ml-0">
            {{ errorMessages.name }}
          </span>
        </div>

        <!-- Phase Type -->
        <div class="col-md-6 form-group mb-2">
          <label class="mb-0">
            Phase Type 
          </label>

          <input v-model="phase.type" class="form-control" type="text" />

        </div>

      </div>

      <!-- Active -->
      <div class="form-group mb-2">
        <label>
          <input type="checkbox" v-model="phase.active" class="mr-1" />
          Active
        </label>
      </div>

      <div class="text-right">
        <button class="save_btn py-1 px-3" @click="submitPhase">
          {{ isEditMode ? 'Update' : 'Create' }}
        </button>
      </div>

    </template>
  </customModal>
</template>
<script src="./PhaseModal.js"></script>